import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const nl2br = (text) => {
	if (typeof text !== 'string') {
		return text;
	}

	let lines = text.split('\n');
	return lines.map((line, i) => {
		if (i === lines.length - 1) {
			return line;
		}

		return (
			<Fragment key={i}>
				{line}
				<br />
			</Fragment>
		);
	});
};

/**
 * This function returns a formatted message string. It accepts a
 * message string with variables defined as "hello {var}!" and
 * accepts a shallow values object which are used to fill the placeholders
 * in the message.
 */
const Message = ({ message, values }) => {
	const parts = message.split(/\{|\}/g);
	const children = [];

	for (let i = 0; i < parts.length; i++) {
		if (i % 2 === 0) {
			children.push(nl2br(parts[i]));
		} else {
			children.push(<Fragment key={i}>{values[parts[i]]}</Fragment>);
		}
	}

	return children;
};

Message.propTypes = {
	message: PropTypes.string.isRequired,
	values: PropTypes.object,
};

Message.defaultProps = {
	message: null,
	values: null,
};

export default Message;
